// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"779":"056bf7cd","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"338":"9afd8bd6d07335faf44e","545":"1cd0b6724431e9c5e9f7","779":"eaeb5b1e3aa7955680e5","883":"5dd9d8474d66ea97692a"}[chunkId] + ".js";
};